<template>
    <div class="container">
        <div class="title">
            {{$l('streamPopover/title')}}
        </div>
        <div class="options">
            <div v-if="$p('streamPopover/audio')" @click="audioClicked" class="option">{{$l('streamPopover/Audio')}}</div>
            <div v-if="url" class="audio-iframe">
                <el-row class="audio-buttons" :gutter="10">
                    <el-col :span="12"><el-button @click="audioRecordingClicked"  :disabled="!audioPlaying" class="audio-button" size="small">{{$l(recordingButtonText) }}</el-button></el-col>
                    <el-col :span="12"><el-button class="audio-button" size="small" @click="stopAudioStreamClicked">{{$l(streamButtonText)}}</el-button></el-col>
                </el-row>
                <audio v-if="audioPlaying" ref="audioController" class="audio-controller" controls > 
                    <source v-bind:src="url">
                </audio>
            </div>
            <div v-if="$p('streamPopover/video') && getSettingsAddons.video == '1'" :class="getClass('video')" @click="videoClicked" class="option">{{$l('streamPopover/Video')}}</div>
        </div>
        
    </div>
</template>

<style scoped>
    .container{
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        
    }
    .title{
        border-bottom:1px solid #e9edef ;
        padding-bottom: 10px;
        font-size: 15px;
        margin-bottom: 5px;
        text-align: center;
        font-weight: 600;
    }
    .option{
        text-align: center;
        padding: 5px;
        cursor: default;
    }
    .option:hover{
        background-color: rgba(0,0,0,0.05);
    }
    .option.disabled{
        color:#e9edef;
    }
    .option.disabled:hover{
        background-color: transparent;
    }
    .audio-buttons{
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .audio-button{
        width:100%;
    }
    .audio-iframe{
        text-align: center;
        overflow: hidden;
    }
    .audio-iframe iframe{
        border: none;
    }
    .disabled-button{
        cursor: not-allowed !important;
        color:#e9edef;
    }
</style>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

export default {
    data: function(){
        return {
            url:undefined,
            audioPlaying: false,
            audioRecording: false
        }
    },
    computed:{
        ...mapGetters([
            'getSettingsAddons'
        ]),
        streamButtonText: function(){
            return (this.audioPlaying)?'streamPopover/StopStream':'streamPopover/StartStream';
        },
        recordingButtonText: function(){
            return (this.audioRecording)?'streamPopover/StopManRec':'streamPopover/StartManRec';
        },

    },
    methods:{
        ...mapActions([
            'startAudioStream',
            'stopAudioStream',
            'startAudioRecording',
            'stopAudioRecording'
        ]),
        audioClicked: function(){
            if(!this.url)
                this.startAudioStream()
                    .then(data=>{
                        this.audioPlaying = true;
                        this.url = data.data;
                    })
            else
                this.url = undefined;
        },
        stopAudioStreamClicked: function(){
            if(this.audioPlaying){
                this.stopAudioStream(this.$store)
                    .then(data=>{
                        this.audioPlaying = false;
                    })
            }else{
                this.startAudioStream()
                    .then(data=>{
                        this.audioPlaying = true;
                        this.url = data.data;
                    })
            }
        },
        getClass:function(menu){
            if(this.getSettingsAddons[menu]=='0') return 'disabled-button';
            return '';
        },
        videoClicked: function(){
            if(this.getSettingsAddons['video']=='0') return;
            window.open('/video');
        },
        audioRecordingClicked: function(){
            if(this.audioRecording){
                this.stopAudioRecording()
                    .then(data=>{
                        this.audioRecording = false;
                    })
            }else{
                this.startAudioRecording()
                    .then(data=>{
                        this.audioRecording = true;
                    })
            }
        }
    },
    destroyed: function(){
        this.url = undefined;
    }
}
</script>



// WEBPACK FOOTER //
// StreamPopover.vue?49b8ca19